/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Contacts_Description_Multipleprospects3Inputs */

const en_coinvestments_editemail_contacts_description_multipleprospects3 = /** @type {(inputs: Coinvestments_Editemail_Contacts_Description_Multipleprospects3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will unlock platform access for all permissioned users at the selected organisations. Users will be able to view the deal overview, but must sign the NDA to access sensitive data and documents.`)
};

/**
* | output |
* | --- |
* | "This will unlock platform access for all permissioned users at the selected organisations. Users will be able to view the deal overview, but must sign the ND..." |
*
* @param {Coinvestments_Editemail_Contacts_Description_Multipleprospects3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_contacts_description_multipleprospects3 = /** @type {((inputs?: Coinvestments_Editemail_Contacts_Description_Multipleprospects3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Contacts_Description_Multipleprospects3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_contacts_description_multipleprospects3(inputs)
});
export { coinvestments_editemail_contacts_description_multipleprospects3 as "coInvestments_editEmail_contacts_description_multipleProspects" }